import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// STORE AND PURCHASE DASHBOARD SUMMARY API
// RoleId/UserId drive backend CC-scoping: for roles with ApplicableForCC='Yes',
// results are restricted to the cost centers assigned to this user in UserCostCenters.
// ==============================================

export const getSNPDashboardSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetSNPDashboardSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ SNP Dashboard Summary API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Drill-down behind the Pending Indents / MRR / PO tiles (type = 'Indent' | 'MRR' | 'PO') — every
// document still under process, with the workflow level it is pending at (PendingLevel) and the
// role(s) at that level (PendingWithRole).
export const getSNPPendingDetails = async ({ type, roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetSNPPendingDetails`,
            { params: { Type: type, RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ SNP Pending Details API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
